module.exports = __webpack_public_path__ + "static/img/Laura-home.37de438.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Laura-home.jpg
// module id = nY/Z
// module chunks = 1